// src/utils/statusSymbol.js

export function statusSymbol(state, defaultValue) {
  switch (state) {
    case 'reserved':
      return 'clock'; // clock
    case 'locked':
      return 'lock'; // lock
    case 'active':
      return 'confirm'; // confirm
    case 'inactive':
      return 'clock'; // clock
    case 'inactive_retrying':
      return 'clock'; // clock
    case 'optin':
      return 'success'; // success
    case 'opt_in_possible':
      return 'success'; // success
    case 'terminated':
      return 'cancel'; // cancel
    case 'failed':
      return 'error'; // error
    case 'SUCCESS':
      return 'confirm';
    case 'WARNING':
      return 'adieresis';
    case 'ERROR':
      return 'error';
    case 'INFO':
      return 'information';
    case 'PROMPT':
      return 'less';
    case 'LOADING':
      return 'reload';
    default:
      return defaultValue; // clock
  }
}

export default statusSymbol;
